import { render } from "./gce-pd.vue?vue&type=template&id=350bbc5c"
import script from "./gce-pd.vue?vue&type=script&lang=js"
export * from "./gce-pd.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__